export const SearchUser = "Search User"
export const EnterVendorEmail = "Enter Vendor Email"
export const VendorEmail = "Search by vendor's email id"
export const VendorName = "Vendor Name"
export const Email = "Email"
export const Role = "Role"
export const Status = "Status"
export const Action = "Action"
export const EmailValid = "Please enter the valid email"
export const VendorEmailID  = "Please enter vendor email Id"
export const EditUserDetails = "Edit User Details"
export const Mandatory  = "indicates mandatory field"
export const UserRole  = "User Role"
export const ActiveStatus  = "Active Status"
export const Cancel = "Cancel"
export const Select = "Select"
export const Admin = "Admin"
export const View = "View"
export const Active = "Active"
export const InActive = "Inactive"
export const Invalid = "Invalid Vendor Email"
export const RoleEmpty = "Please select role"
export const StatusEmpty = "Please select status"
export const NoDataAvailable = "No data available"